import React from 'react';

import { RadioButtonPanels } from '@eika/radio-button';

import { BlockType, Piwik, SiteCoreDictionary } from '../types';

interface SelectBlockTypeFormProps {
    selectedBlockType: BlockType | undefined;
    setSelectedBlockType: (blockType: BlockType | undefined) => void;
    selectedBlockTypeError: string | undefined;
    dictionary: SiteCoreDictionary;
    includeTerminateAccountOption: boolean;
    piwik: Piwik | undefined;
}

const SelectBlockTypeForm = ({
    selectedBlockType,
    setSelectedBlockType,
    selectedBlockTypeError,
    dictionary,
    includeTerminateAccountOption,
    piwik,
}: SelectBlockTypeFormProps) => {
    const { blockStep0Legend, blockStep0Description, blockSoftTitle, blockHardTitle, terminateAccountTitle } =
        dictionary;

    const OPTIONS = [
        {
            id: BlockType.SOFT_BLOCK,
            value: BlockType.SOFT_BLOCK,
            label: blockSoftTitle,
            ...{
                'data-track-id': piwik?.blockCardForm?.selectBlockType?.dataTrackId,
                'data-track-linkname': BlockType.SOFT_BLOCK,
            },
        },
        {
            id: BlockType.HARD_BLOCK,
            value: BlockType.HARD_BLOCK,
            label: blockHardTitle,
            ...{
                'data-track-id': piwik?.blockCardForm?.selectBlockType?.dataTrackId,
                'data-track-linkname': BlockType.HARD_BLOCK,
            },
        },
    ];

    if (includeTerminateAccountOption) {
        OPTIONS.push({
            id: BlockType.TERMINATE_ACCOUNT,
            value: BlockType.TERMINATE_ACCOUNT,
            label: terminateAccountTitle,
            ...{
                'data-track-id': piwik?.blockCardForm?.selectBlockType?.dataTrackId,
                'data-track-linkname': BlockType.TERMINATE_ACCOUNT,
            },
        });
    }

    const toBlockType = (blockTypeString: string): BlockType | undefined => {
        if (Object.values<string>(BlockType).includes(blockTypeString)) {
            return BlockType[blockTypeString];
        }

        return undefined;
    };

    return (
        <RadioButtonPanels
            label={blockStep0Legend}
            sublabel={blockStep0Description}
            name="sperr-kort"
            onChange={(value) => setSelectedBlockType(toBlockType(value))}
            selectedOption={selectedBlockType}
            options={OPTIONS}
            errorMessage={selectedBlockTypeError}
        />
    );
};

export default SelectBlockTypeForm;
